import type { SessionLifecycleSegmentData } from './types';

const SESSION_TYPE_GENITIVE: Record<string, string> = {
  запись: 'записи',
  правки: 'правок',
  монтаж: 'монтажа',
};

const READER_NOT_SET = 'Чтец не указан';

function formatReaders(names: string[]): string {
  const list = names.map((n) => n.trim()).filter(Boolean);
  if (list.length === 0) return READER_NOT_SET;
  return list.join(', ');
}

function formatNoteTitleContent(title: string | null, content: string | null): string {
  const t = title?.trim() ?? '';
  const c = content?.trim() ?? '';
  if (t && c) return `${t} • ${c}`;
  return t || c || 'Заметка';
}

function sessionTypeGenitive(sessionType: string): string {
  return SESSION_TYPE_GENITIVE[sessionType] ?? sessionType;
}

export function formatSessionCreatedLabel(lifecycle: SessionLifecycleSegmentData): string {
  if (lifecycle.session_type === 'заметка') {
    return `Создана заметка ${formatNoteTitleContent(lifecycle.title, lifecycle.content)}`;
  }
  const readers = formatReaders(lifecycle.reader_names);
  const project = lifecycle.project_name?.trim() || '—';
  return `Создана сессия ${sessionTypeGenitive(lifecycle.session_type)}: ${readers} • ${project}`;
}

export function formatSessionDeletedLabel(lifecycle: SessionLifecycleSegmentData): string {
  if (lifecycle.session_type === 'заметка') {
    return `Удалена заметка ${formatNoteTitleContent(lifecycle.title, lifecycle.content)}`;
  }
  const readers = formatReaders(lifecycle.reader_names);
  const project = lifecycle.project_name?.trim() || '—';
  return `Удалена сессия ${sessionTypeGenitive(lifecycle.session_type)}: ${readers} • ${project}`;
}

export function formatSessionRestoredLabel(lifecycle: SessionLifecycleSegmentData): string {
  if (lifecycle.session_type === 'заметка') {
    return `Восстановлена заметка ${formatNoteTitleContent(lifecycle.title, lifecycle.content)}`;
  }
  const readers = formatReaders(lifecycle.reader_names);
  const project = lifecycle.project_name?.trim() || '—';
  return `Восстановлена сессия ${sessionTypeGenitive(lifecycle.session_type)}: ${readers} • ${project}`;
}
